import * as R from 'ramda';
import React from 'react';
import Button from '@material-ui/core/Button';
import GetAppIcon from '@material-ui/icons/GetApp';
import { connect } from 'react-redux';
import { parse as convertFromCSV } from 'papaparse';
import { crudUpdateMany } from 'ra-core';
import {showNotification} from 'react-admin';

import {START_UPLOAD_CSV_TO_STATIONS} from '../../redux/stations/actions';


function existsDoublesInList(valuesList) {
    const counts = [];
    for(var i = 0; i <= valuesList.length; i++) {
        if(counts[valuesList[i]] === undefined) {
            counts[valuesList[i]] = 1;
        } else {
            return true;
        }
    }
    return false;
}

function existsBadDevicesSerials(serials) {
    const result = serials.reduce((acc, elm) => {
        const regex = /^\d{4}-\d{5,6}$/;
        if (regex.test(elm) === false) {
            acc += 1;
        }
        return acc;
    }, 0);
    return result !== 0;
}


function validateCSVFile(values) {
    const deviceUids = values.flatMap(elm => Object.values(elm)).filter(elm => Boolean(elm));
    const errors = [];
    if (existsDoublesInList(deviceUids)){
        errors.push("found double device serial")
    }
    if (existsBadDevicesSerials(deviceUids)){
        errors.push('found wrong device serial')
    }
    return errors;
}


const ImportButton = (props) => {
    const { resource, dispatch, basePath } = props;

    const handleChange = (e) => {
        const file = e.target.files && e.target.files[0];
        if (file) {
            convertFromCSV(file, {
                delimiter: ',',
                complete: (result) => {
                    const { data } = result;
                    const keys = data[0];
                    const values = data.slice(1).filter(row => row[0] !== "").map(row => {
                        const value = {};
                        keys.forEach((key, index) => {
                            value[key] = row[index];
                        });
                        return value;
                    });
                    const errors = validateCSVFile(values);
                    if (!R.isEmpty(errors)) {
                        const firstError = `File broken: ${errors.pop()}`;
                        return dispatch(showNotification(firstError, "warning"));
                    }
                    return dispatch({type: START_UPLOAD_CSV_TO_STATIONS, payload: {serial_numbers: values}});
                }
            });
        }
    };

    return (
        <>
            <input
                type="file"
                id="text-button-file"
                style={{ display: 'none' }}
                accept='.csv'
                onChange={handleChange}
                value=''
            />
            <label htmlFor="text-button-file" style={{ display: 'inline-flex', alignItems: 'center' }}>
                <Button
                    color="primary"
                    component="span"
                >
                    <GetAppIcon style={{ transform: 'rotate(180deg)', fontSize: 20 }} />
                    <span style={{ paddingLeft: '0.5em' }}>Import CSV</span>
                </Button>
            </label>
        </>
    );
};

export default connect()(ImportButton);